/**
 * ProjectEditDialog — 项目信息 Tab
 */
import React from 'react';

interface ProjectInfoTabProps {
  name: string;
  setName: (v: string) => void;
  description: string;
  setDescription: (v: string) => void;
  descriptiveLevel: string;
  setDescriptiveLevel: (v: string) => void;
  onSave: () => void;
}

export default function ProjectInfoTab({
  name, setName, description, setDescription,
  descriptiveLevel, setDescriptiveLevel, onSave,
}: ProjectInfoTabProps) {
  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">项目名称</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          placeholder="请输入项目名称" onKeyDown={(e) => e.key === 'Enter' && onSave()} autoFocus />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">项目描述</label>
        <textarea value={description} onChange={(e) => setDescription(e.target.value)} rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-y"
          placeholder="项目描述（可选）" />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">提纲描述详细度</label>
        <select value={descriptiveLevel} onChange={(e) => setDescriptiveLevel(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white">
          <option value="simple">简单 — 1-2句话概括</option>
          <option value="detailed">详细 — 2-4句话说明（推荐）</option>
          <option value="very_detailed">非常详细 — 4-6句话展开</option>
        </select>
      </div>
    </div>
  );
}
